import React from "react";
import PropTypes from "prop-types";
import { Col, Container, NavLink, Row } from "reactstrap";
import { Field } from "formik";
import { ItemTitle } from "../../../commons/elements/index";
import EventDetails from "../../../commons/event-details";

const propTypes = {
  pkg: PropTypes.shape({
    packageId: PropTypes.number,
    name: PropTypes.string,
    cost: PropTypes.number,
    currency: PropTypes.string,
    productList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        startTime: PropTypes.string
      })
    )
  }).isRequired,
  selectPackage: PropTypes.func.isRequired,
  showingDetails: PropTypes.func.isRequired,
  expandedId: PropTypes.number
};

const defaultProps = {
  expandedId: undefined
};

function EventPackage(props) {
  const { pkg, selectPackage, showingDetails, expandedId } = props;

  return (
    <Container fluid className="product-container">
      <Row>
        <Col className="col-1 fixed-width">
          <Field
            type="radio"
            name="productId"
            className="product-option-radio"
            value={`${pkg.packageId}`}
            onClick={() => selectPackage({ ...pkg, id: pkg.packageId })}
          />
        </Col>
        <Col>
          <Row>
            <ItemTitle title={pkg.name} />
          </Row>
          <Row className="event-product-cost">
            {pkg.currency === "CAD" ? (
              <span>{`CA$${pkg.cost / 100}`}</span>
            ) : (
              <span>{`$${pkg.cost / 100}`}</span>
            )}
          </Row>
          <Row>
            {pkg.productList && pkg.productList.length > 0 && (
              <NavLink
                className="pl-0 pb-0"
                onClick={() => {
                  showingDetails(pkg.packageId);
                }}
              >
                {`See what's included in this product`}
              </NavLink>
            )}
          </Row>
          {expandedId === pkg.packageId && (
            <Row>
              <span className="product-content-disclaimer my-1">
                Subject to change by content provider.
              </span>
            </Row>
          )}
        </Col>
      </Row>
      {expandedId === pkg.packageId && (
        <Row className="packaged-products-list">
          <div className="fixed-width" />
          <Col className="p-0">
            {pkg.productList.map((event) => (
              <EventDetails
                key={`event-content-${event.id}`}
                startTime={event.startTime}
                title={event.title}
              />
            ))}
          </Col>
        </Row>
      )}
    </Container>
  );
}

EventPackage.propTypes = propTypes;
EventPackage.defaultProps = defaultProps;

export default EventPackage;
